import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const EditInvoiceSchema = z.object({
  invoiceKey: z
    .string({
      required_error: i18nMessage("boInvoices:invoiceForm.invoiceKeyRequired"),
      message: i18nMessage("boInvoices:invoiceForm.invoiceKeyRequired"),
    })
    .min(1, i18nMessage("boInvoices:invoiceForm.invoiceKeyRequired")),
  invoicePDFKey: z
    .string({
      required_error: i18nMessage("boInvoices:invoiceForm.invoicePdfKeyRequired"),
      message: i18nMessage("boInvoices:invoiceForm.invoicePdfKeyRequired"),
    })
    .min(1, i18nMessage("boInvoices:invoiceForm.invoicePdfKeyRequired")),
  amountToBill: z
    .number({
      required_error: i18nMessage("boInvoices:invoiceForm.amountToBillRequired"),
      message: i18nMessage("boInvoices:invoiceForm.amountToBillRequired"),
    })
    .min(0, i18nMessage("boInvoices:invoiceForm.amountToBillRequired")),
  totalTva: z
    .number({
      required_error: i18nMessage("boInvoices:invoiceForm.totalTvaRequired"),
      message: i18nMessage("boInvoices:invoiceForm.totalTvaRequired"),
    })
    .min(0, i18nMessage("boInvoices:invoiceForm.totalTvaRequired")),
  totalHT: z
    .number({
      required_error: i18nMessage("boInvoices:invoiceForm.totalHtRequired"),
      message: i18nMessage("boInvoices:invoiceForm.totalHtRequired"),
    })
    .min(0, i18nMessage("boInvoices:invoiceForm.totalHtRequired")),
});

export type EditInvoiceFormData = z.infer<typeof EditInvoiceSchema>;

export const AdjustmentInvoiceSchema = z.object({
  adjustment: z.number({
    required_error: i18nMessage("boInvoices:invoiceForm.adjustmentRequired"),
    message: i18nMessage("boInvoices:invoiceForm.adjustmentRequired"),
  }),
});

export type AdjustmentInvoiceFormData = z.infer<typeof AdjustmentInvoiceSchema>;

export const CreateInvoiceSchema = z.object({
  companyId: z
    .string({
      required_error: i18nMessage("boInvoices:invoiceForm.companyRequired"),
      message: i18nMessage("boInvoices:invoiceForm.companyRequired"),
    })
    .min(1, i18nMessage("boInvoices:invoiceForm.companyRequired")),
  billingEntityId: z
    .string({
      required_error: i18nMessage("boInvoices:invoiceForm.billingEntityRequired"),
      message: i18nMessage("boInvoices:invoiceForm.billingEntityRequired"),
    })
    .min(1, i18nMessage("boInvoices:invoiceForm.billingEntityRequired")),
  invoiceKey: z
    .string({
      required_error: i18nMessage("boInvoices:invoiceForm.invoiceKeyRequired"),
      message: i18nMessage("boInvoices:invoiceForm.invoiceKeyRequired"),
    })
    .min(1, i18nMessage("boInvoices:invoiceForm.invoiceKeyRequired")),
  amountToBill: z
    .number({
      required_error: i18nMessage("boInvoices:invoiceForm.amountToBillRequired"),
      message: i18nMessage("boInvoices:invoiceForm.amountToBillRequired"),
    })
    .min(0, i18nMessage("boInvoices:invoiceForm.amountToBillRequired")),
  totalTva: z
    .number({
      required_error: i18nMessage("boInvoices:invoiceForm.totalTvaRequired"),
      message: i18nMessage("boInvoices:invoiceForm.totalTvaRequired"),
    })
    .min(0, i18nMessage("boInvoices:invoiceForm.totalTvaRequired")),
  totalHT: z
    .number({
      required_error: i18nMessage("boInvoices:invoiceForm.totalHtRequired"),
      message: i18nMessage("boInvoices:invoiceForm.totalHtRequired"),
    })
    .min(0, i18nMessage("boInvoices:invoiceForm.totalHtRequired")),
  month: z
    .number({
      required_error: i18nMessage("boInvoices:invoiceForm.monthRequired"),
      message: i18nMessage("boInvoices:invoiceForm.monthRequired"),
      coerce: true,
    })
    .min(0, i18nMessage("boInvoices:invoiceForm.monthInvalid"))
    .max(12, i18nMessage("boInvoices:invoiceForm.monthInvalid")),
  year: z
    .number({
      required_error: i18nMessage("boInvoices:invoiceForm.yearRequired"),
      message: i18nMessage("boInvoices:invoiceForm.yearRequired"),
      coerce: true,
    })
    .min(new Date().getFullYear() - 5, i18nMessage("boInvoices:invoiceForm.yearInvalid"))
    .max(new Date().getFullYear(), i18nMessage("boInvoices:invoiceForm.yearInvalid")),
});

export type CreateInvoiceFormData = z.infer<typeof CreateInvoiceSchema>;
